import React from 'react';
import Header from "./header";
import {styles} from "./menu/styles";
import {SkyLightStateless} from "react-skylight";
import RedirectIfNotLogged from "./menu/redirect-if-not-logged";
import {RaisedButton, TextField} from "material-ui";
import * as validator from "../general/validators/validator";
import {connect} from "react-redux";
import * as ErrorAction from "../redux/action/error-action";
import request from "../config/axios-config";

class AddModalComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: true,
            error: {
                name: null
            }
        };

    }

    closeModal = () => {
        this.setState({
            modalIsOpen: false,
            alreadyExists: false,
            name: this.props.initialName,
        });
        this.props.onCancel();
    };

    componentWillUnmount() {
        this.props.hideError();
    }

    componentDidMount() {
        this.setState({
            modalIsOpen: this.state.modalIsOpen,
            alreadyExists: false,
            name: this.props.initialName
        });
    }

    onNameChange = (e) => {
        this.setState({name: e.target.value});
    };

    onSave = () => {
        let url = "";
        if (validator.isEmpty(this.state.name)) {
            this.setState({
                error: {
                    name: "Lipseste numele"
                }
            });
            return;
        }
        let name = this.state.name.trim();
        if (this.props.id) {
            //edit
            url = this.props.url + name + "&id=" + this.props.id;
        } else {
            //add new
            url = this.props.url + this.state.name;
        }

        request({
            url: url,
            method: "POST"
        }).then(json => {
            this.closeModal();
        }).catch(err => {
            this.props.showError("Adaugarea a esuat!");
            this.setState({
                modalIsOpen: true,
                alreadyExists: true
            })
        })
    };

    render() {

        return (
            <div>
                <RedirectIfNotLogged/>

                <SkyLightStateless
                    isVisible={this.state.modalIsOpen}
                    dialogStyles={{...styles.defaultDialogStyles, top: '15%'}}
                    onCloseClicked={this.closeModal}
                    onOverlayClicked={this.closeModal}
                    title={<Header title={this.props.title}/>}
                >
                    <div style={{width: '100%', textAlign: 'center', marginTop: '20px'}}>
                        <div>
                            <TextField
                                hintText={"Numele"}
                                value={this.state.name}
                                errorText={this.state.error.name}
                                onChange={this.onNameChange}
                            />
                            <RaisedButton
                                style={{marginLeft: '20px'}}
                                primary
                                label={"Save"}
                                onClick={() => this.onSave()}/>
                        </div>

                    </div>
                </SkyLightStateless>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        userDepartment: state.login.user.department,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showError: (text) => dispatch(ErrorAction.showError(text)),
        hideError: () => dispatch(ErrorAction.hideError())
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddModalComponent)